config.$inject = ["$stateProvider", "$urlRouterProvider"];
export function config($stateProvider: ng.ui.IStateProvider, $urlRouterProvider: ng.ui.IUrlRouterProvider): void {
    $stateProvider
    .state("admin", {
        abstract: true,
        url: "/admin",
        template: "<admin-page></admin-page>",
        resolve: {
          account: ['AccountService', (AccountService) => {
            return AccountService.$promise;
          }],
          isAdmin: ['AccountService', (AccountService) => {
            return AccountService.getAdmin();
          }]
        }
    })
    .state("admin.user", {
        url: "/user/:type?",
        views: {
          admin: {
            template: "<user-management></user-management>"
          }
        }
    })
    .state("admin.organization", {
        url: "/organization/:type?",
        views: {
          admin: {
            template: "<organization-management></organization-management>"
          }
        }
    })
    .state("admin.classification", {
        url: "/classification/:type?",
        views: {
          admin: {
            template: "<classification-management></classification-management>"
          }
        }
    })
    .state("admin.data", {
        url: "/data/:type?",
        views: {
          admin: {
            template: "<datas-management></datas-management>"
          }
        }
    })
    .state("admin.external", {
      url: "/external",
      views: {
        admin: {
          template: "<external-dataset-page></external-dataset-page>"
        }
      }
    })
    .state("admin.configuration", {
      url: "/configuration",
      views: {
        admin: {
          template: "<configuration-management></configuration-management>"
        }
      }
    })
    .state("admin.report", {
      url: "/report/:type?",
      views: {
        admin: {
          template: "<report-page></report-page>"
        }
      }
    });
    $urlRouterProvider.when("/admin", "/admin/user/");
}
